import { actionCreator, stateChangeOnlyActionCreator } from '../../store/actionCreators';
import {
  CLEAR_ALL_INTERACTIONS_ACTIONTYPE,
  CREATE_NEW_BLT_ENTITY_ACTIONTYPE,
  DELETE_BLT_ENTITY_ACTIONTYPE,
  GET_ALERT_LOGS_ACTIONTYPE,
  GET_ALL_BEACON_INTERACITONS_ACTIONTYPE,
  GET_ALL_BLT_ENTITIES_ACTIONTYPE,
  GET_ALL_INTERATIONS_ACTIONTYPE,
  GET_ROOMS_DATA_ACTIONTYPE,
  MARK_ALERTS_DONE_POPOVER_TRIGGER_ACTIONTYPE,
  MARK_ALL_INTERACTIONS_DONE_ACTIONTYPE,
  MARK_DONE_POPUP_INTERACTIONS_ACTIONTYPE,
  SEND_CONFIG_TO_GATEWAY_ACTIONTYPE,
  SET_ACTIVE_BLT_ENTITY_ACTIONTYPE,
  SET_ACTIVE_BLT_ENTITY_TYPE_ACTIONTYPE,
  SET_ACTIVE_ROOM_ACTIONTYPE,
  SET_BLT_GATEWAY_CONFIG_ACTIONTYPE,
  TRIGGER_BLT_ADD_ROOM_CONFIGURE_DIALOG_ACTIONTYPE,
  TRIGGER_BLT_ENTITY_CONFIGURE_DIALOG_ACTIONTYPE,
  TRIGGER_BLT_ENTITY_DIALOG_ACTIONTYPE,
  UPDATE_BLT_ENTITY_ACTIONTYPE,
} from './actionTypes';

export const getAllBltEntitiesAction = actionCreator(GET_ALL_BLT_ENTITIES_ACTIONTYPE);
export const getAllBeaconInteractionsAction = actionCreator(GET_ALL_BEACON_INTERACITONS_ACTIONTYPE);
export const setBltGatewayConfigAction = actionCreator(SET_BLT_GATEWAY_CONFIG_ACTIONTYPE);
export const createNewBltEntityAction = actionCreator(CREATE_NEW_BLT_ENTITY_ACTIONTYPE);
export const updateBltEntityAction = actionCreator(UPDATE_BLT_ENTITY_ACTIONTYPE);
export const deleteBltEntityAction = actionCreator(DELETE_BLT_ENTITY_ACTIONTYPE);
export const getAllDevicesInterationsAction = actionCreator(GET_ALL_INTERATIONS_ACTIONTYPE);
export const sendConfigToGatewayAction = actionCreator(SEND_CONFIG_TO_GATEWAY_ACTIONTYPE);
export const markAllInteractionsDoneAction = actionCreator(MARK_ALL_INTERACTIONS_DONE_ACTIONTYPE);
export const getAlertLogsAction = actionCreator(GET_ALERT_LOGS_ACTIONTYPE);
export const getRoomsDataAction = actionCreator(GET_ROOMS_DATA_ACTIONTYPE);

export const triggerBltEntityAddUpdateDialogAction = stateChangeOnlyActionCreator(TRIGGER_BLT_ENTITY_DIALOG_ACTIONTYPE);
export const triggerBltEntityConfigureDialogAction = stateChangeOnlyActionCreator(TRIGGER_BLT_ENTITY_CONFIGURE_DIALOG_ACTIONTYPE);
export const triggerAddRoomConfigureDialogAction = stateChangeOnlyActionCreator(TRIGGER_BLT_ADD_ROOM_CONFIGURE_DIALOG_ACTIONTYPE);
export const setActiveBltEntityAction = stateChangeOnlyActionCreator(SET_ACTIVE_BLT_ENTITY_ACTIONTYPE);
export const setActiveBltEntityTypeAction = stateChangeOnlyActionCreator(SET_ACTIVE_BLT_ENTITY_TYPE_ACTIONTYPE);
export const setActiveRoomAction = stateChangeOnlyActionCreator(SET_ACTIVE_ROOM_ACTIONTYPE);
export const markAlertsDonePopoverTriggerAction = stateChangeOnlyActionCreator(MARK_ALERTS_DONE_POPOVER_TRIGGER_ACTIONTYPE);
export const markDonePopupInteractionsAction = stateChangeOnlyActionCreator(MARK_DONE_POPUP_INTERACTIONS_ACTIONTYPE);
export const clearAllInteractionsAction = stateChangeOnlyActionCreator(CLEAR_ALL_INTERACTIONS_ACTIONTYPE);
